// src/utils/rut.js

/**
 * Elimina todos los caracteres que no sean dígitos o 'K/k'
 * y convierte a mayúsculas.
 * @param {string} rut 
 * @returns {string}
 */
function cleanRut(rut) {
  return rut.replace(/[^0-9kK]/g, '').toUpperCase();
}

/**
 * Valida el dígito verificador de un RUT chileno.
 * @param {string} rawRut  - RUT en cualquier formato
 * @returns {boolean}      - true si es válido
 */
function validateRut(rawRut) {
  const v = cleanRut(rawRut);
  if (v.length < 2) return false;

  let sum = 0;
  let mul = 2;

  // Recorre de derecha a izquierda (sin considerar el DV)
  for (let i = v.length - 2; i >= 0; i--) {
    sum += Number(v[i]) * mul;
    mul = mul === 7 ? 2 : mul + 1;
  }

  const mod  = 11 - (sum % 11);
  const dv   = mod === 11 ? '0' : mod === 10 ? 'K' : String(mod);

  return dv === v.slice(-1);
}

/**
 * Formatea un RUT limpio (sólo dígitos+DV) como xx.xxx.xxx-D.
 * Si recibe un string con puntos/guión, primero lo limpia.
 * @param {string} rawRut
 * @returns {string}
 */
function formatRut(rawRut) {
  const v = cleanRut(rawRut);
  if (v.length < 2) return v;

  const body = v.slice(0, -1);
  const dv   = v.slice(-1);
  // Inserta puntos cada 3 dígitos, de derecha a izquierda
  const withDots = body
    .split('')
    .reverse()
    .join('')
    .match(/.{1,3}/g)
    .join('.')
    .split('')
    .reverse()
    .join('');

  return `${withDots}-${dv}`;
}

module.exports = {
  cleanRut,
  validateRut,
  formatRut
};
